



































import SfModal from "~/themes/fiskarsMoominDefault/components/components/molecules/SfModal/SfModal.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import {useUiState} from "~/composables";
import {useVSFContext} from "@vue-storefront/core";
import { COOKIES } from '~/helpers/constants';

export default {
  name: "ChangeLocaleModal",
  components: {SfButton, SfHeading, SfModal},
  props: {
    defaultCountry: {
      type: String,
      default: 'Finland'
    },
    activeCountry: {
      type: String,
      default: 'Finland'
    },
    defaultLocaleCode: {
      type: String,
      default: 'fi-fi'
    }
  },
  setup(props) {
    const { app: {$cookies, $config}, i18n } = useVSFContext();

    const {
      toggleCountrySelectorModal,
      isCountryConfirmationOpen,
      isCountrySelectorOpen,
      toggleCountryConfirmationModal
    } = useUiState();


    const REMAINING_BUTTON = i18n.t("LOCALE_CHANGE.REMAINING_BUTTON");
    const GET_TO_DEFAULT_LOCALE_BUTTON = i18n.t("LOCALE_CHANGE.GET_TO_DEFAULT_LOCALE_BUTTON");
    const SELECT_DIFFERENT_LOCALE = i18n.t("LOCALE_CHANGE.SELECT_DIFFERENT_LOCALE");
    const GET_TO_DEFAULT_LOCALE_TITLE = i18n.t("LOCALE_CHANGE.GET_TO_DEFAULT_LOCALE_TITLE");
    const CONFIRMATION_TITLE = i18n.t("LOCALE_CHANGE.CONFIRMATION_TITLE");
    const DETAILS = i18n.t("LOCALE_CHANGE.DETAILS");

    const _remainingButton = REMAINING_BUTTON.replace('{0}', props.activeCountry);
    const _getToDefaultLocaleButton = GET_TO_DEFAULT_LOCALE_BUTTON.replace('{0}', props.defaultCountry);
    const _getToDefaultLocaleTitle = GET_TO_DEFAULT_LOCALE_TITLE.replace('{0}', props.defaultCountry);
    const setCookieLocale = (geoCountry, geoLocaleCode) => {
      if (geoLocaleCode === "int") {
        const countryCodeMapping = {"poland": "pl", "denmark": "dk", "germany": "de"};
        const geoCountryFormated= geoCountry.toLowerCase();
        $cookies.set(COOKIES.MCRCCODE, countryCodeMapping[geoCountryFormated], {
          maxAge: 60 * 60 * 24 * 15,
          path: "/", // Cookie path
        });

        $cookies.set(COOKIES.MCRCNTRY, geoCountryFormated, {
          maxAge: 60 * 60 * 24 * 15,
          path: "/", // Cookie path
        });
      }

      const href = `${$config.productionURL}/${geoLocaleCode}/`;
      window.location.href = href;
    };
    const stayOnCurrentLocale = () => {
      $cookies.set(COOKIES.CONFIRMATION_LOCALE_CHANGE, true, {maxAge: 60 * 60 * 24 * 15, path: "/",});


      toggleCountryConfirmationModal();
    }


    const openSelector = () => {

      toggleCountrySelectorModal();
    }

    return {
      openSelector,
      SELECT_DIFFERENT_LOCALE,
      CONFIRMATION_TITLE,
      DETAILS,
      _remainingButton,
      _getToDefaultLocaleButton,
      _getToDefaultLocaleTitle,
      setCookieLocale,
      isCountryConfirmationOpen,
      toggleCountryConfirmationModal,
      stayOnCurrentLocale,
      isCountrySelectorOpen
    }
  }
}
